var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBalancer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.261719,
    width: 32,
    height: 32,
    rx: 16,
    fill: "url(#paint0_linear_34_748)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2381 11.1C10.2381 12.4239 12.8723 13.5008 16.12 13.5008C19.3677 13.5008 22.0019 12.4239 22.0019 11.1C22.0019 9.77614 19.3677 8.69922 16.12 8.69922C12.8723 8.69922 10.2381 9.77614 10.2381 11.1ZM16.1199 18.302C11.9442 18.302 8.55741 16.9613 8.55741 15.3066C8.55741 14.3892 9.60135 13.5672 11.2379 13.0203C12.4058 13.6448 14.1561 14.0435 16.1199 14.0435C18.0838 14.0435 19.834 13.6448 21.0019 13.0203C22.6419 13.5707 23.6824 14.3892 23.6824 15.3066C23.6859 16.9613 20.2991 18.302 16.1199 18.302ZM16 23.8245C10.4306 23.8245 5.91663 22.207 5.91663 20.0398C5.91663 18.9089 7.14613 17.8901 9.11404 17.1724C10.65 18.1632 13.2275 18.6708 16.1497 18.6708C19.0023 18.6708 21.524 18.0511 23.074 17.1023C24.9304 17.8131 26.0833 18.8039 26.0833 19.8962C26.0833 22.067 21.5693 23.8245 16 23.8245Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34_748",
    x1: 16,
    y1: 0.261719,
    x2: 16,
    y2: 32.2617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalancer);
export default __webpack_public_path__ + "static/media/balancer.ff5d892d3981fbcb084a045fc13d83a3.svg";
export { ForwardRef as ReactComponent };